import Axios from './config';
import { BroadcastChannel } from 'broadcast-channel';
import { getCookieEnvironment } from '../collums-components/helpers';

const bcOptions = { type: 'localstorage', webWorkerSupport: false };
const authBroadcastChannel = new BroadcastChannel('collums-lockscreen', bcOptions);

class AuthApi {
    static login({ email, password }) {
        return Axios({
            method: 'POST',
            url: '/login',
            data: { email, password }
        });
    }

    static getMe() {
        return Axios({
            method: 'GET',
            url: '/user/me'
        });
    }

    static resetPassword({ email }) {
        return Axios({
            method: 'POST',
            url: '/reset-password',
            data: { email, redirect: 'collums' }
        });
    }

    static changePassword({ password, code }) {
        return Axios({
            method: 'POST',
            url: `/reset-password/${code}`,
            data: { password }
        });
    }

    static lockUser(setCookie, { silent = false } = {}) {
        const environment = getCookieEnvironment();
        if (silent) {
            const parts = ['isLocked=true'];
            if (environment.path) parts.push(`path=${environment.path}`);
            if (environment.domain) parts.push(`domain=${environment.domain}`);
            document.cookie = parts.join('; ');
        } else {
            setCookie('isLocked', true, environment);
            authBroadcastChannel.postMessage(JSON.stringify({ token: '' }));
        }
    }

    static lockSession() {
        return Axios({
            method: 'POST',
            url: '/session/lock'
        });
    }

    static isUserLocked() {
        return Axios({
            method: 'GET',
            url: '/is-user-locked'
        });
    }
}

export default AuthApi;
